import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, FocusTrap, Select, TextInput } from '@mantine/core'
import { useUserPaymentForm } from './schema/form'
import { getListPaymentPlatform, submitPaymentPlatform } from '../../../../../services/payment'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { useDispatch } from 'react-redux'
import { getUserDetail } from '../../../../../store/userDetail'

const FormAdjustAccountUser = ({ userId, dataUserPayment, onCloseForm }) => {
  const dispatch = useDispatch()
  const form = useUserPaymentForm()
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingPayment, setLoadingPayment] = useState(true)
  const [availablePayment, setAvailablePayment] = useState([])

  const submitAccountUser = async (value) => {
    setLoadingForm(true)
    const payload = {
      ...value,
      user_id: userId
    }
    try {
      const response = await submitPaymentPlatform(payload)
      if (response.success) {
        notificationSuccess('Update Payment Platform User Successfully', 'This data has been updated')
        setLoadingForm(false)
        onCloseForm()
        dispatch(getUserDetail(userId))
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      const errorForm = error.response.data.errors
      Object.keys(errorForm).forEach((key) => {
        console.log('key', key)
        form.setFieldError(key, errorForm[key][0])
      })
      notificationError('Update Payment Platform User Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
      setLoadingForm(false)
    }
  }

  const handleGetListAvailablePayment = async () => {
    setLoadingPayment(true)
    try {
      const response = await getListPaymentPlatform()
      if (response.success) {
        const resData = response.data
        const filteredDataAvailable = resData.filter((val) => val.attributes.available === true)
        const remapData = filteredDataAvailable.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: val.attributes.name
          }
        })
        setAvailablePayment(remapData)
      } else {
        setAvailablePayment([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingPayment(false)
    }
  }

  useEffect(() => {
    handleGetListAvailablePayment()
  }, [])

  useEffect(() => {
    if (!loadingPayment) {
      handleSetForm(dataUserPayment)
    }
    // eslint-disable-next-line
  }, [loadingPayment])

  const handleSetForm = (data) => {
    let paymentId = ''
    if (availablePayment.length > 0) {
      const findData = availablePayment.find((val) => val.label === `${data.withdraw_platform}`)
      if (findData) {
        paymentId = `${findData.value}`
      }
    }
    const detail = {
      payment_id: paymentId,
      remarks: data.remarks,
      value: data.value
    }

    form.initialize(detail)
    form.setValues(detail)
  }

  return (
    <Box>
      <FocusTrap.InitialFocus />
      <Box mb='sm'>
        <Select
          label="Method Payment"
          placeholder='Select Method Payment'
          data={availablePayment}
          key={form.key('payment_id')}
          {...form.getInputProps('payment_id')}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <TextInput
          label='Bank Account Name'
          key={form.key('remarks')}
          {...form.getInputProps('remarks')}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mb='sm'>
        <TextInput
          label='Bank Account ID'
          key={form.key('value')}
          {...form.getInputProps('value')}
          withAsterisk
          size='xs'
          type='number'
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => submitAccountUser(value))}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustAccountUser